import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as Parse from 'parse';
import { GoogleCalendarEvent } from 'backend/interfaces/calendar.interface';
import { CalendarEvent } from 'angular-calendar';
@Injectable({
  providedIn: 'root'
})
export class AppointmentService {
  appointments = new BehaviorSubject<GoogleCalendarEvent[]>(null) 
  appointments$ = this.appointments.asObservable();
  appointment = new BehaviorSubject<CalendarEvent>(null);
  appointment$ = this.appointment.asObservable();
  constructor() { }

  setAppointment(appointment: CalendarEvent){
    this.appointment.next(appointment);
  }

  createAppointment(event: GoogleCalendarEvent): Promise<any>{
    return Parse.Cloud.run('createBooking', { event });
  }

  updateAppointment(event: any): Promise<any>{
    return Parse.Cloud.run('updateBooking', { event });
  }

  acceptAppointmentRequest(event: GoogleCalendarEvent): Promise<any>{
    return Parse.Cloud.run('acceptAppointmentRequest', { event });
  }


  deleteAppointment(id: string): Promise<any>{
    return Parse.Cloud.run('deleteBooking', { id });
  }

  rejectAppointment(appointmentRequestId: string | number): Promise<any>{
    return Parse.Cloud.run('rejectAppointmentRequest', { appointmentRequestId });
  }
  
  getCalendarBusy(): Promise<any>{
    const from = "2023-01-01T00:00:00.000Z";
    const to = "2023-04-01T00:00:00.000Z";
    return Parse.Cloud.run('getCalendarBusy', { from, to });
  }

  getCalendarEvents(): Promise<any>{
    return Parse.Cloud.run('getCalendarEvents');
  }

  getAppointment(appointmentId: string): Promise<any>{
    return Parse.Cloud.run('getAppointment', {appointmentId: appointmentId});
  }

  getPatientAppointments(email: string): Promise<any>{
    return Parse.Cloud.run('getPatientAppointments', {patientEmail: email});
  }

  createAppointmentRequest(appointment: any): Promise<any>{
    return Parse.Cloud.run('createAppointmentRequest', { appointment });
  }

  getAppointmentRequests(): Promise<any>{
    return Parse.Cloud.run('getAppointmentRequests');
  }

  getAppointmentsByLocation(location: string): Promise<any>{
    return Parse.Cloud.run('getAppointmentsByLocation', {location});
  }

  getAppointmentsByEmail(email: string): Promise<any>{
    return Parse.Cloud.run('getAppointmentsByEmail', {email});
  }

  sendReminderEmails(): Promise<any>{
    return Parse.Cloud.run('sendReminderEmails');
  }
  
}
